'use strict';

var resolve  = require('./resolve')
  , passthru = require('./passthru');

module.exports = function (data, context/*, options*/) {
	return passthru.apply(null, resolve(data, context, arguments[2]));
};



//////////////////
// WEBPACK FOOTER
// ./~/es6-template-strings/resolve-to-string.js
// module id = 1695
// module chunks = 0